import Api from "../api/api";

export default async (data) => {
  return await Api.post("reset-password", data, {});
};
